import type { Geo } from '@pst/biz';
import Bowser from 'bowser';

interface GSDKQuery {
  role_id: string;
  server_id: string;
  channel_id: string;
  platform: string;
  iid: string;
  device_id: string;
  device_type: string;
  aid: string;
  app_name: string;
  device_platform: string;
  os_version: string;
  sdk_version: string;
  channel: string;
  sdk_language: string;
  app_package: string;
  ac: string;
  app_version: string;
  device_model: string;
  device_brand: string;
  language: string;
  resolution: string;
  os: string;
  sdk_app_id: string;
  version_code: string;
  _rticket: string;
  custom: string;
  channel_op: string;
  tz_name: string;
  tz_offset: string;
  g_download_source: string;
  login_way: string;
  sys_region: string;
  event_seq: string;
  game_id: string;
  access_token: string;
  user_unique_id: string;
  open_id: string;
  gsdk_pc_request_source: string;
  intl_info: string;
}

interface SkyTeaHeaderParams {
  idfa: string;
  vid: string;
  screen_width: string;
  screen_height: string;
  os_version: string;
  device_type: string;
  resolution: string;
  dpi: string;
  os: string;
  os_name: string;
  device_platform: string;
  sdk_version: string;
  version_code: string;
  app_version: string;
  build_number: string;
  language: string;
  sdk_language: string;
  channel: string;
  channel_op: string;
  app_name: string;
  aid: string;
  sdk_app_id: string;
  iid: string;
  device_id: string;
  adjust_id: string;
  adid: string;
  _rticket: string;
  intl_info_gsdk?: string;
  custom_gsdk?: string;
  intl_info: {
    carrier_region: string;
    /** @example CN */
    app_region: string;
    app_language: string;
    sys_language: string;
    sys_region: string;
    gps_country: string;
    gps_city: string;
    timezone_name: string;
  };
  ac: string;
  openudid: string;
  version_name: string;
  device_brand: string;
  os_api: string;
  manifest_version_code: string;
  update_version_code: string;
  access_token: string;
  device_name: string;
  app_package: string;
  device_model: string;
  custom: {
    country: string;
    province: string;
    city: string;
    environment: string;
    login_way: string;
    gsdk_version: string;
    real_package_name: string;
    channel_op: string;
    client_ip: string;
    is_emulator: number;
    tz_offset: number;
    google_aid: string;
    appsflyer_id: string;
    adjust_id: string;
    web_id: string;
    refer_url: string;
    url: string;
    game_id: string;
    session_id: string;
    device_brand: string;
    device_model: string;
    device_id: number;
    user_unique_id: string;
  };
  tz_name: string;
  tz_offset: number;
  appsflyer_id: string;
}

const bowser = Bowser.getParser(window.navigator.userAgent);

export class SkyTeaHeader {
  header: SkyTeaHeaderParams;
  constructor() {
    this.header = {
      idfa: '',
      vid: '',
      screen_width: String(window.outerWidth),
      screen_height: String(window.outerHeight),
      os_version: bowser.getOSVersion(),
      device_type: '',
      resolution: `${window.outerWidth}*${window.outerHeight}`,
      dpi: '',
      os: bowser.getOSName(),
      os_name: bowser.getOSName(),
      device_platform: '',
      sdk_version: '',
      version_code: '',
      app_version: '',
      build_number: '',
      language: '',
      sdk_language: '',
      channel: '',
      channel_op: '',
      app_name: '',
      aid: '',
      sdk_app_id: '',
      iid: '',
      device_id: '',
      adjust_id: '',
      adid: '',
      _rticket: '',
      intl_info: {
        carrier_region: '',
        app_region: '',
        app_language: '',
        sys_language: '',
        sys_region: '',
        gps_country: '',
        gps_city: '',
        timezone_name: '',
      },
      ac: '',
      openudid: '',
      version_name: '',
      device_brand: '',
      os_api: '',
      manifest_version_code: '',
      update_version_code: '',
      access_token: '',
      device_name: '',
      app_package: '',
      device_model: '',
      custom: {
        country: '',
        province: '',
        city: '',
        environment: 'online',
        login_way: '',
        gsdk_version: '',
        real_package_name: '',
        channel_op: '',
        client_ip: '',
        is_emulator: 0,
        tz_offset: new Date().getTimezoneOffset(),
        google_aid: '',
        appsflyer_id: '',
        adjust_id: '',
        web_id: '',
        refer_url: document.referrer || '',
        url: location.origin + location.pathname,
        game_id: '',
        session_id: '',
        device_brand: '',
        device_model: '',
        device_id: 0,
        user_unique_id: '',
      },
      tz_name: new Intl.DateTimeFormat('en-US', { timeZoneName: 'long' }).resolvedOptions().timeZone,
      tz_offset: new Date().getTimezoneOffset(),
      appsflyer_id: '',
    };
  }

  setHeaderAfterGeo({
    appId,
    geoData,
    language,
    google_aid,
    appsflyer_id,
  }: {
    appId: number;
    language?: string;
    geoData?: Geo['original'];
    google_aid: string;
    appsflyer_id: string;
  }) {
    const options: [value: string | undefined, currentValue: string, updateValue: (value: string) => void][] =
      [
        // [
        //   geoData?.location?.Country?.Code,
        //   this.header.intl_info.app_region,
        //   (value) => (this.header.intl_info.app_region = value),
        // ],
        // [
        //   geoData?.location?.Country?.Code,
        //   this.header.intl_info.sys_region,
        //   (value) => (this.header.intl_info.sys_region = value),
        // ],
        // [
        //   geoData?.location?.Country?.Name,
        //   this.header.intl_info.gps_country,
        //   (value) => (this.header.intl_info.gps_country = value),
        // ],
        // [
        //   geoData?.location?.City?.Name,
        //   this.header.intl_info.gps_city,
        //   (value) => (this.header.intl_info.gps_city = value),
        // ],
        [
          geoData?.location?.City?.Name,
          this.header.custom.city,
          (value) => (this.header.custom.city = value),
        ],
        [
          geoData?.location?.Country?.Name,
          this.header.custom.country,
          (value) => (this.header.custom.country = value),
        ],
        [
          geoData?.location?.Subdivisions?.Name,
          this.header.custom.province,
          (value) => (this.header.custom.province = value),
        ],
        [geoData?.ip, this.header.custom.client_ip, (value) => (this.header.custom.client_ip = value)],
        [
          String(google_aid),
          this.header.custom.google_aid,
          (value) => (this.header.custom.google_aid = value),
        ],
        [
          String(appsflyer_id),
          this.header.custom.appsflyer_id,
          (value) => (this.header.custom.appsflyer_id = value),
        ],
        [String(appsflyer_id), this.header.appsflyer_id, (value) => (this.header.appsflyer_id = value)],
        [String(appId), this.header.aid, (value) => (this.header.aid = value)],
        [language, this.header.language, (value) => (this.header.language = value)],
        // [
        //   language,
        //   this.header.intl_info.app_language,
        //   (value) => (this.header.intl_info.app_language = value),
        // ],
        // [
        //   language,
        //   this.header.intl_info.sys_language,
        //   (value) => (this.header.intl_info.sys_language = value),
        // ],
      ];
    options.forEach(([value, currentValue, updateValue]) => {
      // 更新的值有才覆盖，如果之前已经设置过了（gsdk），则不覆盖
      if (value && !currentValue) {
        updateValue(value);
      }
    });
  }

  setHeaderAfterGsdk({ intl_info, custom, ...params }: Partial<GSDKQuery>) {
    (Object.entries(params) as [keyof SkyTeaHeaderParams, string][]).forEach(([key, value]) => {
      if (typeof this.header[key] === 'string') {
        (this.header as any)[key] = value;
      }
    });

    if (params.device_id) {
      this.header.custom.device_id = Number(params.device_id);
    }
    if (params.sdk_app_id) {
      this.header.custom.game_id = params.sdk_app_id;
    }
    if (params.sdk_version) {
      this.header.custom.gsdk_version = params.sdk_version;
    }
    if (params.app_version) {
      this.header.version_name = params.app_version;
    }

    this.header.intl_info_gsdk = intl_info || '';
    this.header.custom_gsdk = custom || '';
  }

  getHeader({ user_unique_id }: { user_unique_id: string }) {
    const { intl_info, ...header } = this.header;
    return {
      ...header,
      _rticket: String(Math.floor(Date.now() / 1000)),
      custom: this.header.custom_gsdk
        ? this.parseString(this.header.custom_gsdk)
        : {
            ...this.header.custom,
            user_unique_id,
            web_id: user_unique_id,
          },
      // 优先使用 gsdk 的
      // intl_info: this.header.intl_info_gsdk || JSON.stringify(this.header.intl_info),
    };
  }

  parseString(str: string) {
    try {
      const value = JSON.parse(str);
      return typeof value === 'object' ? value : {};
    } catch {
      return {};
    }
  }
}
